import { render, staticRenderFns } from "./PInfoTip.vue?vue&type=template&id=03c24c47&scoped=true&"
import script from "./PInfoTip.vue?vue&type=script&lang=js&"
export * from "./PInfoTip.vue?vue&type=script&lang=js&"
import style0 from "./PInfoTip.vue?vue&type=style&index=0&id=03c24c47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c24c47",
  null
  
)

export default component.exports